let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gfl86")).then(() => parcelRequire('d4bbl'));